import { headerConst } from '../constants/header.constant';

export function AddPlateformType(plateform) { return { type: headerConst.ADDPLATEFORMTYPE, plateform } }
export function GetPlateformType() { return { type: headerConst.GetPlateformType } }

